<template>
    <div class="succeed">
      <div class="succeed-a">
        <span class="icon"><van-icon name="passed" /></span>
        <h3>订单支付成功</h3>
        <span class="price">￥{{ order.pay_price }}</span>
        <p>仓库正在为您备货中</p>
      </div>
      <div class="succeed-btn">
        <router-link :to="{ name: 'ordersShow', query: { id: order.id }}"><span>查看订单</span></router-link>
        <router-link to="/"><span class="sp-2">返回首页</span></router-link>
      </div>
      <div class="van-hairline--top"></div>
      <div class="succeed-rwm">
        <p class="p-0">颐吉颐贸易</p>
        <img src="../../assets/images/rwm.jpg" width="170" />
        <p class="p-1">长按关注公众号</p>
        <p class="p-2">关注公众号后方便查看信息</p>
      </div>

      <wxNoShare />
    </div>
</template>
<script>
  import { Cell, CellGroup, Button, Icon } from 'vant'

  export default {
    components: {
      [Button.name]: Button,
      [CellGroup.name]: CellGroup,
      [Cell.name]: Cell,
      [Icon.name]: Icon,
    },
    name: 'paymentSucceed',
    data() {
      return {
        order: []
      };
    },
    created() {
      this.getOrders()
    },
    methods: {
      getOrders() {
        this.$api.get('orders/show', {id: this.$route.query.id}, r=>{
          this.order = r.data
        })
      }
    }
  }
</script>

<style scoped>
  .succeed{
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    position: fixed;
    overflow: hidden;
  }
  .succeed-a{
    margin-top: 15%;
    text-align: center;
  }
  .succeed-a .icon{
    font-size: 60px;
    color:#07c160;
  }
  .succeed-a h3{
    margin-top: 0px;
    font-weight: normal;
  }
  .succeed-a .price{
    font-size: 24px;
    font-weight: bold;
  }
  .succeed-a p{
    color:#969799;
    font-size: 14px;
  }
  .succeed-btn{
    text-align: center;
    margin: 10% 0;
  }
  .succeed-btn span{
    background:#ee0a24;
    color:#fff;
    display: inline-block;
    padding: 7px 30px;
    border-radius: 22px;
    margin: 0 3%;
    border:1px solid #ee0a24;
  }
  .succeed-btn .sp-2{
    background:#fff;
    color:#969799;
    border:1px solid #969799;
  }
  .succeed-rwm{
    text-align: center;
    padding-top:10px;
  }
  .succeed-rwm .p-0{
    margin: 0;
  }
  .succeed-rwm .p-1{
    margin: 3px 0;
    font-size: 14px;
  }
  .succeed-rwm .p-2{
    font-size: 14px;
    color:#969799;
  }
</style>



// WEBPACK FOOTER //
// src/views/payment/succeed.vue